<template>
  <div class="wrapper row justify-content-center align-items-center">
    <div class="col-12 col-sm-6 col-md-6 col-lg-4">
      <form @submit.prevent="onSubmit">
        <div class="card mx-auto">
          <div class="card-body">
            <h1 class="card-title">Sign In</h1>
            <div class="alert alert-danger" v-if="error">{{error}}</div>
            <div class="form-group">
              <label for="email">Email</label>
              <input type="email" id="email" name="email" class="form-control" v-model="email" v-focus v-validate="{ required: true, email: true }" autofocus>
              <div class="invalid-feedback" v-show="errors.has('email')">{{ errors.first('email') }}</div>
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input type="password" id="password" name="password" class="form-control" v-model="password" v-validate="{ required: true }">
              <div class="invalid-feedback" v-show="errors.has('password')">{{ errors.first('password') }}</div>
            </div>
          </div>
          <div class="card-footer d-flex">
            <button type="submit" class="btn btn-primary ml-auto">Sign in</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      error: null
    };
  },

  computed: {
    ...mapGetters(["isLoggedIn"])
  },

  methods: {
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          return;
        }
        this.submitData();
      });
    },

    submitData() {
      const formData = {
        email: this.email,
        password: this.password
      };
      this.$store
        .dispatch("signIn", formData)
        .then(() => {
          this.error = null;
          this.$router.replace({ name: "home" });
        })
        .catch(error => {
          this.error = error.response.data.message;
        });
    }
  },

  beforeMount() {
    if (this.isLoggedIn) {
      this.$router.replace({ name: "home" });
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 24px;
  font-weight: 300;
  text-align: center;
}

.wrapper {
  height: 100vh;
}
</style>
